/**
 * Contenu éditorial de la page /seminaire.
 * Texte fourni par le client (fichier 04) — variables renseignées par le client.
 */

export const SEMINAIRE_CONTENT = {
  fr: {
    meta: {
      title: "Séminaire d'entreprise à Ville-d'Avray (92)",
      description:
        "Salle de séminaire dans un hôtel particulier à Ville-d'Avray, entre Paris, La Défense et Versailles. Journée d'étude 110 € HT, demi-journée 90 € HT, déjeuner du chef inclus.",
      keywords:
        "séminaire entreprise Ville d'Avray, salle de séminaire 92, journée d'étude La Défense, réunion Versailles, comité de direction",
    },
    breadcrumb: [
      { label: "Accueil", to: "/" },
      { label: "Événements", to: "/evenements" },
      { label: "Séminaire" },
    ],
    overline: "Séminaires & événements d'entreprise · Ville-d'Avray (92)",
    h1: "Séminaire d'entreprise à Ville-d'Avray, dans un hôtel particulier",
    intro:
      "Réunir vos équipes loin de leurs bureaux sans les emmener loin de Paris : L'Entracte accueille vos séminaires, journées d'étude et comités de direction dans un hôtel particulier du XIXe siècle à Ville-d'Avray, entre Paris, La Défense et Versailles. Salle privatisée, équipement fourni, déjeuner du chef inclus : vous vous concentrez sur l'ordre du jour, nous nous occupons du reste.",
    ctaDevis: "Demander un devis séminaire",
    ctaCall: "Appeler le 01 82 00 18 67",
    heroAlt: "Salle de séminaire privatisée à L'Entracte, Ville-d'Avray",

    brief: {
      title: "Votre séminaire en bref",
      caption: "Informations clés pour un séminaire à L'Entracte",
      rows: [
        ["Lieu", "Hôtel particulier, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Capacité", "De 12 à 80 participants en réunion"],
        ["Formules", "Demi-journée 90 € HT, journée 110 € HT par personne"],
        [
          "Inclus",
          "Salle privatisée, Wi-Fi haut débit, écran de projection, pauses, déjeuner 3 plats boissons comprises",
        ],
        ["Horaires", "Journée d'étude de 9 h à 18 h"],
        [
          "Accès",
          "15 minutes de La Défense, 15 minutes de Paris · Parking : stationnement à proximité immédiate du restaurant",
        ],
      ],
    },

    formulas: {
      title: "Nos formules séminaire",
      caption: "Comparaison des formules demi-journée et journée d'étude",
      head: ["", "Demi-journée d'étude", "Journée d'étude"],
      rows: [
        ["Tarif", "90 € HT par personne", "110 € HT par personne"],
        ["Accueil", "Café, thé, jus de fruits et viennoiseries", "Petit-déjeuner d'accueil"],
        ["Salle", "Privatisée pour la matinée ou l'après-midi", "Privatisée de 9 h à 18 h"],
        ["Pause", "—", "Pause gourmande l'après-midi"],
        [
          "Déjeuner",
          "Déjeuner du chef en 3 plats, boissons incluses",
          "Déjeuner du chef en 3 plats, boissons incluses",
        ],
        [
          "Équipement",
          "Wi-Fi haut débit, écran de projection, mobilier confortable",
          "Wi-Fi haut débit, écran de projection, mobilier confortable",
        ],
      ],
      note:
        "Tarifs hors taxes, par personne, TVA applicable en sus. Nos menus sont élaborés à partir de produits frais et de saison ; les options végétariennes et les régimes spécifiques sont possibles sur demande.",
      alt: "Déjeuner de séminaire préparé par le chef de L'Entracte",
    },

    beyond: {
      title: "Au-delà de la journée d'étude",
      items: [
        {
          label: "Comité de direction et réunion stratégique",
          body: "une salle privatisée, au calme, pour travailler en petit comité.",
        },
        {
          label: "Déjeuner ou dîner d'affaires",
          body: "un espace réservé pour recevoir clients et partenaires autour de la cuisine du chef.",
        },
        {
          label: "Soirée d'entreprise et fête de fin d'année",
          body: "dîner assis ou cocktail dînatoire, en privatisation totale, jusqu'à 130 invités.",
        },
        {
          label: "Cocktail sur la terrasse",
          body: "lancement de produit, pot de départ ou afterwork sur la terrasse de 240 m².",
        },
      ],
      groupsIntro: "Groupes et autocaristes : consultez notre page dédiée aux",
      groupsLinkLabel: "groupes et autocaristes",
      groupsLink: "/restaurant-groupes-autocaristes-proche-versailles-92-lentracte",
      alt: "Pause café sur la terrasse de L'Entracte pendant un séminaire",
    },

    why: {
      title: "Pourquoi organiser votre séminaire à L'Entracte ?",
      items: [
        {
          label: "Un cadre qui change du bureau.",
          body: "L'environnement verdoyant de Ville-d'Avray et la terrasse de 240 m² sur parc offrent de vraies pauses, propices aux échanges.",
        },
        {
          label: "Tout est inclus.",
          body: "Salle, équipement, pauses et déjeuner sont compris dans le tarif par personne, sans frais cachés de location.",
        },
        {
          label: "Une vraie cuisine de restaurant.",
          body: "Le déjeuner est préparé sur place par notre chef, entièrement fait maison.",
        },
        {
          label: "Facile d'accès.",
          body: "Vos équipes arrivent de Paris, de La Défense ou de Versailles en quelques minutes, et le parking simplifie la logistique.",
        },
      ],
    },

    access: {
      title: "Accès depuis Paris, La Défense et Versailles",
      intro: "L'Entracte est situé au 3 rue de Versailles, 92410 Ville-d'Avray, dans les Hauts-de-Seine :",
      items: [
        "Depuis La Défense : 15 minutes.",
        "Depuis Paris : 15 minutes.",
        "Depuis Versailles : 15 minutes.",
      ],
      note:
        "Gare de Sèvres – Ville-d'Avray à 1 km, desservie par la ligne L (depuis Paris Saint-Lazare et La Défense) et la ligne U (depuis La Défense). Parking : stationnement à proximité immédiate du restaurant.",
    },

    faqTitle: "Questions fréquentes sur les séminaires",
    faq: [
      {
        question: "Combien de participants pouvez-vous accueillir ?",
        answer:
          "De 12 à 80 participants en configuration réunion. Pour une soirée d'entreprise en cocktail, jusqu'à 130 invités.",
      },
      {
        question: "Quel est le prix d'un séminaire à L'Entracte ?",
        answer:
          "La demi-journée d'étude est à 90 € HT par personne et la journée d'étude à 110 € HT par personne. Salle privatisée, équipement, pauses et déjeuner 3 plats boissons comprises sont inclus.",
      },
      {
        question: "La demi-journée peut-elle se tenir le matin ou l'après-midi ?",
        answer:
          "Oui, la demi-journée d'étude peut se dérouler le matin ou l'après-midi, avec le déjeuner inclus dans les deux cas.",
      },
      {
        question: "Quel équipement est fourni ?",
        answer:
          "Le Wi-Fi haut débit, un écran de projection et le mobilier sont inclus dans toutes nos formules. Pour tout besoin complémentaire (visioconférence, micro, paperboard), précisez-le dans votre demande de devis.",
      },
      {
        question: "Peut-on prolonger le séminaire par un dîner ou une soirée ?",
        answer:
          "Oui, sur demande. Indiquez-le dans votre demande de devis et nous vous ferons une proposition sur-mesure.",
      },
      {
        question: "Les régimes alimentaires particuliers sont-ils pris en compte ?",
        answer:
          "Oui, les options végétariennes et les régimes spécifiques sont possibles, à préciser lors de la réservation.",
      },
      {
        question: "Y a-t-il un parking ?",
        answer: "Stationnement à proximité immédiate du restaurant.",
      },
      {
        question: "Combien de temps à l'avance faut-il réserver ?",
        answer: "Comptez environ 2 mois à l'avance.",
      },
    ],

    devis: {
      title: "Réservez votre séminaire",
      body:
        "Indiquez-nous la date, le nombre de participants et le format souhaité : nous vous adressons un devis détaillé.",
      contact:
        "Téléphone : 01 82 00 18 67 · E-mail : restaurantlentractevda@gmail.com · Adresse : 3 rue de Versailles, 92410 Ville-d'Avray",
    },

    related: {
      title: "Aller plus loin",
      links: [
        { to: "/evenements", label: "Toutes nos réceptions privées" },
        { to: "/menu", label: "La carte du restaurant" },
        {
          to: "/restaurant-groupes-autocaristes-proche-versailles-92-lentracte",
          label: "Groupes et autocaristes",
        },
      ],
    },

    eventType: "Séminaire / entreprise",
  },

  en: {
    meta: {
      title: "Corporate seminars in Ville-d'Avray (92)",
      description:
        "Seminar room in a private townhouse in Ville-d'Avray, between Paris, La Défense and Versailles. Full-day package €110 excl. VAT, half-day €90 excl. VAT, the chef's lunch included.",
      keywords:
        "corporate seminar Ville d'Avray, meeting room 92, study day La Défense, meeting Versailles, board meeting",
    },
    breadcrumb: [
      { label: "Home", to: "/" },
      { label: "Events", to: "/evenements" },
      { label: "Seminar" },
    ],
    overline: "Seminars & corporate events · Ville-d'Avray (92)",
    h1: "Corporate seminars in Ville-d'Avray, in a private townhouse",
    intro:
      "Bringing your teams away from the office without taking them far from Paris: L'Entracte hosts your seminars, study days and board meetings in a 19th-century private townhouse in Ville-d'Avray, between Paris, La Défense and Versailles. Private room, equipment provided, the chef's lunch included: you focus on the agenda, we take care of the rest.",
    ctaDevis: "Request a seminar quote",
    ctaCall: "Call +33 1 82 00 18 67",
    heroAlt: "Private seminar room at L'Entracte, Ville-d'Avray",

    brief: {
      title: "Your seminar at a glance",
      caption: "Key information for a seminar at L'Entracte",
      rows: [
        ["Venue", "Private townhouse, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Capacity", "12 to 80 participants in meeting layout"],
        ["Packages", "Half-day €90 excl. VAT, full day €110 excl. VAT per person"],
        [
          "Included",
          "Private room, high-speed Wi-Fi, projection screen, breaks, 3-course lunch with drinks included",
        ],
        ["Timings", "Study day from 9am to 6pm"],
        [
          "Getting here",
          "15 minutes from La Défense, 15 minutes from Paris · Parking: in the immediate vicinity of the restaurant",
        ],
      ],
    },

    formulas: {
      title: "Our seminar packages",
      caption: "Comparison of the half-day and full-day study packages",
      head: ["", "Half-day study package", "Full-day study package"],
      rows: [
        ["Rate", "€90 excl. VAT per person", "€110 excl. VAT per person"],
        ["Welcome", "Coffee, tea, fruit juice and pastries", "Welcome breakfast"],
        ["Room", "Private for the morning or the afternoon", "Private from 9am to 6pm"],
        ["Break", "—", "Afternoon gourmet break"],
        [
          "Lunch",
          "The chef's 3-course lunch, drinks included",
          "The chef's 3-course lunch, drinks included",
        ],
        [
          "Equipment",
          "High-speed Wi-Fi, projection screen, comfortable furniture",
          "High-speed Wi-Fi, projection screen, comfortable furniture",
        ],
      ],
      note:
        "Rates excluding tax, per person, VAT applicable in addition. Our menus are prepared from fresh seasonal produce; vegetarian options and special diets are available on request.",
      alt: "Seminar lunch prepared by the chef of L'Entracte",
    },

    beyond: {
      title: "Beyond the study day",
      items: [
        {
          label: "Board meetings and strategy sessions",
          body: "a private, quiet room to work in a small group.",
        },
        {
          label: "Business lunch or dinner",
          body: "a reserved space to host clients and partners around the chef's cuisine.",
        },
        {
          label: "Company party and end-of-year celebration",
          body: "seated dinner or standing dinner cocktail, with full venue hire, for up to 130 guests.",
        },
        {
          label: "Cocktail on the terrace",
          body: "product launch, farewell drinks or after-work on the 240 m² terrace.",
        },
      ],
      groupsIntro: "Groups and coach operators: see our dedicated page for",
      groupsLinkLabel: "groups and coach operators",
      groupsLink: "/restaurant-groupes-autocaristes-proche-versailles-92-lentracte",
      alt: "Coffee break on the terrace of L'Entracte during a seminar",
    },

    why: {
      title: "Why hold your seminar at L'Entracte?",
      items: [
        {
          label: "A change of scene from the office.",
          body: "The green surroundings of Ville-d'Avray and the 240 m² terrace overlooking the park offer real breaks, ideal for conversation.",
        },
        {
          label: "Everything is included.",
          body: "Room, equipment, breaks and lunch are included in the per-person rate, with no hidden hire fees.",
        },
        {
          label: "A genuine restaurant kitchen.",
          body: "Lunch is prepared on site by our chef, entirely in-house.",
        },
        {
          label: "Easy to reach.",
          body: "Your teams arrive from Paris, La Défense or Versailles in minutes, and parking simplifies the logistics.",
        },
      ],
    },

    access: {
      title: "Getting here from Paris, La Défense and Versailles",
      intro: "L'Entracte is located at 3 rue de Versailles, 92410 Ville-d'Avray, in the Hauts-de-Seine:",
      items: [
        "From La Défense: 15 minutes.",
        "From Paris: 15 minutes.",
        "From Versailles: 15 minutes.",
      ],
      note:
        "Sèvres – Ville-d'Avray station 1 km away, served by line L (from Paris Saint-Lazare and La Défense) and line U (from La Défense). Parking: in the immediate vicinity of the restaurant.",
    },

    faqTitle: "Frequently asked questions about seminars",
    faq: [
      {
        question: "How many participants can you host?",
        answer:
          "From 12 to 80 participants in meeting layout. For a company evening in cocktail format, up to 130 guests.",
      },
      {
        question: "How much does a seminar at L'Entracte cost?",
        answer:
          "The half-day study package is €90 excl. VAT per person and the full-day study package €110 excl. VAT per person. Private room, equipment, breaks and a 3-course lunch with drinks are included.",
      },
      {
        question: "Can the half day be held in the morning or the afternoon?",
        answer:
          "Yes, the half-day study package can take place in the morning or the afternoon, with lunch included in both cases.",
      },
      {
        question: "What equipment is provided?",
        answer:
          "High-speed Wi-Fi, a projection screen and the furniture are included in all our packages. For any additional needs (video conferencing, microphone, flip chart), mention it in your quote request.",
      },
      {
        question: "Can the seminar be extended with a dinner or an evening event?",
        answer:
          "Yes, on request. Mention it in your quote request and we will make you a bespoke proposal.",
      },
      {
        question: "Are special diets catered for?",
        answer:
          "Yes, vegetarian options and special diets are available, to be specified when booking.",
      },
      {
        question: "Is there parking?",
        answer: "Parking in the immediate vicinity of the restaurant.",
      },
      {
        question: "How far in advance should we book?",
        answer: "Allow around 2 months in advance.",
      },
    ],

    devis: {
      title: "Book your seminar",
      body:
        "Tell us the date, the number of participants and the format you have in mind: we will send you a detailed quote.",
      contact:
        "Phone: +33 1 82 00 18 67 · Email: restaurantlentractevda@gmail.com · Address: 3 rue de Versailles, 92410 Ville-d'Avray",
    },

    related: {
      title: "Go further",
      links: [
        { to: "/evenements", label: "All our private receptions" },
        { to: "/menu", label: "The restaurant menu" },
        {
          to: "/restaurant-groupes-autocaristes-proche-versailles-92-lentracte",
          label: "Groups and coach operators",
        },
      ],
    },

    eventType: "Seminar / corporate",
  },
};
